import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdTimelineOptions } from '@onefootprint/fetch-dashboard';
import type { UserTimeline, UserTimelineEvent, UserTimelineEventDeviceInsight } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
export type DeviceInsightEvent = UserTimeline & {
  event: UserTimelineEventDeviceInsight;
};
const isDeviceInsight = (event: UserTimelineEvent): event is UserTimelineEventDeviceInsight => {
  return event.kind === 'device_insight';
};
const useEntityDeviceInsights = (entityId, asOf) => {
  const $ = _c(7);
  let t0;
  if ($[0] !== entityId) {
    t0 = getEntitiesByFpIdTimelineOptions({
      path: {
        fpId: entityId
      },
      query: {
        kinds: "device_insight",
        pageSize: 100
      }
    });
    $[0] = entityId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== asOf) {
    t1 = data => ({
      ...data,
      data: data.data.filter(e => isDeviceInsight(e.event) && (!asOf || new Date(e.timestamp) <= new Date(asOf))).map(_temp)
    });
    $[2] = asOf;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      ...t0,
      select: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
export default useEntityDeviceInsights;
function _temp(e_0) {
  return e_0 as DeviceInsightEvent;
}